import React from "react";
import { observer } from "mobx-react";
import { NakiNigunAlbumActivityTemplate } from "themes/administration/analytics/pages";
import { NakiNigunAlbumActivityViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiNigunAlbumActivityViewStore(rootStore, componentProps),
    "nakiNigunAlbumActivityViewStore"
)
@observer
class NakiNigunAlbumActivity extends React.Component {
    render() {
        return <NakiNigunAlbumActivityTemplate {...this.props} />;
    }
}

export default NakiNigunAlbumActivity;
